import { getPageUrl } from '@/utils/helpers';

import resolveDate from './resolveDate';
import resolveImage from './resolveImage';
import resolveRTC from './resolveRTC';

const resolveRelatedDocument = ({ rawVal, page, labels = {} }: any) => {
  const {
    title,
    headline,
    shortDescription,
    cardTileImage,
    imagecompound,
    publicationDate,
    url,
    buttonLink,
  } = rawVal;
  const image = cardTileImage || imagecompound;
  return (
    Object.keys(rawVal).length > 0 && {
      ...rawVal,
      cardHeading: title || headline,
      cardImage: image && resolveImage({ rawVal: image, page }),
      cardDescription: resolveRTC({ rawVal: shortDescription }),
      cardPublicationDate: publicationDate && resolveDate({ rawVal: publicationDate }),
      buttonLink: buttonLink || {
        displayText: labels?.read_more || 'Read More',
        href: getPageUrl({ url, page }),
        buttonStyle: 'secondary',
      },
    }
  );
};

export default resolveRelatedDocument;
